import { DownOutlined } from '@ant-design/icons';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Dropdown } from '../../Dropdown';
import { LinkButton } from '../../LinkButton';
const EmptyMenuItem = styled.div `
  padding: 10px;
`;
export const ProjectName = styled.span `
  display: inline-block;
  font-weight: bold;
  margin-right: 5px;
`;
const StyledDropdown = styled(Dropdown) `
  padding: 5px;
`;
export const ProjectDropdown = ({ projects, currentProject, onProjectSwitch, }) => {
    const items = useMemo(() => {
        return projects.length
            ? projects.map((project) => ({
                key: project.id,
                label: project.name,
                onClick: () => onProjectSwitch(project.id),
            }))
            : [
                {
                    key: 'none',
                    label: React.createElement(EmptyMenuItem, null, "No available projects"),
                },
            ];
    }, [projects]);
    return (React.createElement(StyledDropdown, { className: "automation-ProjectDropDown", menu: { items }, trigger: ['click'] },
        React.createElement(LinkButton, null,
            React.createElement(ProjectName, null, currentProject ? currentProject.name : 'Select project'),
            React.createElement(DownOutlined, null))));
};
